var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'is-admin': _vm.$auth.ifGranted('admin') && !_vm.isAdminHome,
    'is-athlete': !_vm.$auth.ifGranted('admin'),
    'is-collapsed': _vm.menu.collapsed
  },attrs:{"id":"app"}},[_c('app-navbar'),_vm._v(" "),_c('div',{attrs:{"id":"app-body"}},[_c('nuxt'),_vm._v(" "),_c('a',{ref:"downloadLink"})],1),_vm._v(" "),(_vm.isSwitchSessionCurtainEnabled)?_c('app-switch-session-curtain'):_vm._e(),_vm._v(" "),_c('cookie-consent-banner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }